module.exports = __webpack_public_path__ + "static/media/eye2.5f2f9b07.svg";